import { useState, useCallback } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export interface UseAlert {
  showAlert: (message: string, severity?: "success" | "info" | "warning" | "error") => void;
  AlertComponent: JSX.Element;
}

export function useAlert(): UseAlert {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<"success" | "info" | "warning" | "error">("info");

  const showAlert = useCallback((msg: string, sev: "success" | "info" | "warning" | "error" = "info") => {
    setMessage(msg);
    setSeverity(sev);
    setOpen(true);
  }, []);

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  const AlertComponent = (
    <Snackbar open={open} autoHideDuration={3500} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
      <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );

  return { showAlert, AlertComponent };
}
